import {
  ValidatingAddress,
  PartialShippingAddress,
  PartialShippingConfig,
  ShippingConfig,
  TrackingInfo,
  CarrierTypeEnum,
  InternalDistribution,
} from 'domains/shippingDomain';
import api from 'utils/api';
import {
  OrgShippingAccountTypeDisplay,
  OrgShippingAddress,
  OrgShippingCarrier,
  OrgShippingConfigDTO,
} from '../domains/orgDomain';

const shippingService = {
  getShippingConfig: async (orgId: number) => {
    return api.get<ShippingConfig>(
      `/api/orgs/${orgId}/shipping/config`,
      undefined,
      undefined,
      {
        useGlobalErrorHandler: false,
      }
    );
  },

  addShippingConfig: async (config: PartialShippingConfig) => {
    return api.post(`/api/orgs/${config.orgId}/shipping/config`, {
      ...config,
    });
  },

  updateShippingConfig: async (config: PartialShippingConfig) => {
    return api.put(`/api/orgs/${config.orgId}/shipping/config`, {
      ...config,
    });
  },

  deleteShippingConfig: async (orgId: number) => {
    return api.delete(`/api/orgs/${orgId}/shipping/config`);
  },

  deleteUPS: async (orgId: number) => {
    return api.delete(`/api/orgs/${orgId}/shipping/config/UPS`);
  },

  deleteFedEx: async (orgId: number) => {
    return api.delete(`/api/orgs/${orgId}/shipping/config/FedEx`);
  },

  deleteUSPS: async (orgId: number) => {
    return api.delete(`/api/orgs/${orgId}/shipping/config/USPS`);
  },

  deleteShippingAddress: async (orgId: number) => {
    return api.delete(`/api/orgs/${orgId}/shipping/config/address`);
  },

  validateAddress: async (config: PartialShippingAddress) => {
    return api.post<ValidatingAddress[]>(
      `/api/shipping/ups/av`,
      {
        ...config,
      },
      {},
      {
        useGlobalErrorHandler: false,
      }
    );
  },

  getTrackingInfo: async (
    carrierType: CarrierTypeEnum,
    trackingNumber: string
  ) => {
    return api.get<TrackingInfo>(
      `/api/shipping/tracking/${carrierType}/${trackingNumber}`
    );
  },
  getInternalDistribution: async (orgId: number) => {
    return api.get<InternalDistribution>(
      `/orgs/${orgId}/shipping/internal-distribution`
    );
  },

  updateInternalDistribution: async (
    orgId: number,
    params: { display: boolean; distributions: string[] }
  ) => {
    return api.post<InternalDistribution>(
      `/orgs/${orgId}/shipping/internal-distribution`,
      params
    );
  },
  getOrgShippingConfig: async (orgId: number) => {
    return api.get<OrgShippingConfigDTO>(`/api/orgs/${orgId}/shipping-config`);
  },
  saveCarrierSorting: async (orgId: number, sort: string) => {
    return api.put(
      `/api/orgs/${orgId}/shipping-config/sort-carriers?sortedSerialNumbers=${sort}`
    );
  },
  updateOrgShippingConfigCarrier: async (
    orgId: number,
    carrier: Partial<OrgShippingCarrier>
  ) => {
    return api.put<OrgShippingCarrier>(
      `/api/orgs/${orgId}/shipping-config/carrier`,
      carrier
    );
  },
  createOrgShippingConfigCarrier: async (
    orgId: number,
    carrier: Partial<OrgShippingCarrier>
  ) => {
    return api.post<OrgShippingCarrier>(
      `/api/orgs/${orgId}/shipping-config/carrier`,
      carrier
    );
  },

  deleteOrgShippingConfigCarrier: async (
    orgId: number,
    serialNumber: number
  ) => {
    return api.delete<OrgShippingCarrier>(
      `/api/orgs/${orgId}/shipping-config/carrier`,
      {
        serialNumber,
      }
    );
  },

  updateOrgShippingConfigAddress: async (
    orgId: number,
    address: OrgShippingAddress
  ) => {
    return api.put<OrgShippingAddress>(
      `/api/orgs/${orgId}/shipping-config/address`,
      address
    );
  },
  updateShippingAccountTypeDisplay: async (
    orgId: number,
    display: Partial<OrgShippingAccountTypeDisplay>
  ) => {
    return api.put<OrgShippingAccountTypeDisplay>(
      `/api/orgs/${orgId}/shipping-config/shipping-account-type-display`,
      display
    );
  },
};
export default shippingService;
